import app from './app'
import auth from './auth'
import company from './company'
import screening from './screenings'
import jobs from './jobs'


export default {
  app,
  auth,
  jobs,
  company,
  screening
}